import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectZipcode, setZipcode } from 'redux/slices/zipcodeSlice';
export const ZipcodeListenerProvider = (): JSX.Element => {
  const dispatch = useDispatch();
  const currentZipcode = useSelector(selectZipcode);
  const zipcodeEventName = 'zipcodeUpdate';
  useEffect(() => {
    window.addEventListener(zipcodeEventName, (e) => {
      const newZipcode = (e as CustomEvent).detail.zipcode;
      if (currentZipcode !== newZipcode) {
        dispatch(setZipcode(newZipcode));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
